import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DateTime } from 'luxon';

@Injectable({
  providedIn: 'root'
})
export class ErrorLogService {

  constructor(
  
  ) { }

  logError(error: HttpErrorResponse | Error | string | {}): void {
    const errorLog = sessionStorage.getItem('errorLog');

    let errorLogArr: any[] = errorLog ? JSON.parse(errorLog) : [];
    if (!Array.isArray(errorLogArr)) {
      errorLogArr = [];
    }
    if (Object.keys(error).length !== 0) {
      const date = DateTime.now().toISO();
      const errorMsg = `[ERROR] - ${date} - 
      Error String: ${typeof error === 'string' ? error : 'N/A'},
      Url:${error instanceof HttpErrorResponse ? error.url : 'N/A'},
      Status:${error instanceof HttpErrorResponse ? error.status : 'N/A'},
      Message:${error instanceof HttpErrorResponse ? error.message : 'N/A'},
      Headers:${error instanceof HttpErrorResponse ? JSON.stringify(error.headers) : 'N/A'},
      Status Text:${error instanceof HttpErrorResponse ? error.statusText : 'N/A'},`;
      
      errorLogArr.push(errorMsg);
      
    }
    sessionStorage.setItem('errorLog', JSON.stringify(errorLogArr));
  }
}
